/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-05
 * @brief EHP 메시지 관리 개발
 *
 ********************************************************************/
import React, { useState } from "react";
import clog from "../../../utils/logUtils";
//component
import MessageTree from "./MessageTree";
import CheckCRUD from "./check/CheckCRUD";
import ErrorCRUD from "./error/ErrorCRUD";
import HttpCRUD from "./http/HttpCRUD";
import AlarmCRUD from "./alarm/AlarmCRUD";
/**
 * @brief EHP 메시지 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function MessageMain(props) {
    //
    const [isMobile, setIsMobile] = useState(false);
    const [adminType, setAdminType] = useState("CHECK"); // CHECK, ERROR, HTTP
    // LIST, CREATE, UPDATE, DELETE, READ, BATCH, SET
    const [workMode, setWorkMode] = useState("LIST");
    const defaultTree = {
        menu: { menuId: "", menuName: "" },
        reload: false
    };
    const [selTree, setSelTree] = useState(defaultTree);
    function handleSelTree(adminType, treeInfo) {
        clog("IN SITETREE : handleCurTree : " + adminType);
        setAdminType(adminType);
        setSelTree(treeInfo);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MessageTree, { selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, adminType: adminType, setAdminType: setAdminType, setPopWin: props.setPopWin }),
        (adminType === "CHECK") && React.createElement(CheckCRUD, { isMobile: isMobile, setIsMobile: setIsMobile, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin }),
        (adminType === "ERROR") && React.createElement(ErrorCRUD, { isMobile: isMobile, setIsMobile: setIsMobile, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin }),
        (adminType === "HTTP") && React.createElement(HttpCRUD, { isMobile: isMobile, setIsMobile: setIsMobile, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin }),
        (adminType === "ALARM") && React.createElement(AlarmCRUD, { isMobile: isMobile, setIsMobile: setIsMobile, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin })));
}
export default MessageMain;
